import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { SearchDataService } from '../../providers/searchDataService';
import { SearchItem } from '../../models/searchitem';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

@Component({
    selector: 'app-search-bar',
    templateUrl: './searchbar.component.html',
    styleUrls: ['./searchbar.component.css']
})
export class SearchBarComponent implements OnInit {

    myControl = new FormControl();
    filteredOptions: Observable<string[]>;
    autoCompleteList: any[]
    searchList:SearchItem[];
    activeClass:string="searchbar";

    @ViewChild('autocompleteInput') autocompleteInput: ElementRef;
    @Output() onSelectedOption = new EventEmitter();

    constructor(private router:Router,private searchDataService: SearchDataService) { }

    ngOnInit() {

        // get all the post
        this.searchDataService.getSearchList().subscribe(list => {
            this.searchList = list;

        });

        // when user types something in input, the value changes will come through this
        this.myControl.valueChanges.subscribe(userInput => {
            this.autoCompleteExpenseList(userInput);
        })
    }

    private autoCompleteExpenseList(input) {
        let categoryList = this.filterCategoryList(input);
        let sortedCategoryList = this.sortCategoryList(categoryList,input);
        this.autoCompleteList = sortedCategoryList;
    }

    // this is where filtering the data happens according to you typed value
    filterCategoryList(val) {
        var categoryList = []
        if (typeof val != "string") {
            return [];
        }
        if (val === '' || val === null) {
            return [];
        }
        /** Searching for the keywords, and returning the searchItem that contains those keywords.
         * Keywords and search value transformed to lower case to facilitate search.
         */
        return val ? this.searchList.filter(s => s.keywords.toLowerCase().indexOf(val.toLowerCase()) != -1)
            : this.searchList;
    }

    /**
     * This is where we will sort the filtered results based on how relevant they are to the keyword searched
     * @param catList category list (pre-filtered)
     * @param input the search keyword
     */
    sortCategoryList(catList,input){
        console.log("CatList:",catList, "input: ",input);
        var sortedArray:any=[];
        var size = catList.length;
        //first push in relevant searchitems (the ones that contain the keyword in the title)
        for (var i = 0; i<size; i++){
            //console.log("catlist title lowercase:",catList[i].title.toLowerCase())
            if (catList[i].title.toLowerCase().includes(input.toLowerCase())){
                sortedArray.push(catList[i]);
            }
        }
        console.log("sortedArray:",sortedArray);

        //then push in the rest of the search results
        for (var i = 0; i<size; i++){
            if (!catList[i].title.toLowerCase().includes(input.toLowerCase())){
                sortedArray.push(catList[i]);
            }
        }
        console.log("sortedArray after:",sortedArray);

        return sortedArray;
    }

    // after you clicked an autosuggest option, this function will show the field you want to show in input
    displayFn(search: SearchItem) {
        // if (search!=null){
        //     //alert(search.path);
        //     this.goToRoute(search.path);
        // }
    }

    goToRoute(path:String){
        if (path!=null){
            alert(path);
            this.router.navigate([path]);
        }
    }

    filterPostList(event) {
        var posts = event.source.value;
        if (!posts) {
            this.searchDataService.searchOption = []
        }
        else {

            this.searchDataService.searchOption=[];   //set to null for now (reset) since we are not searching using multipe keywords
            this.searchDataService.searchOption.push(posts);
            this.onSelectedOption.emit(this.searchDataService.searchOption);
            var page = this.router.url.split("/")[1];
            var searchOption = this.searchDataService.searchOption[0]

            if (searchOption.product[0] == "sgconnect")
              this.router.navigate(["sgconnect"+"/"+ searchOption.path]);
            else if (searchOption.product[0] == "sgconnectedge")
              this.router.navigate(["sgconnectedge"+"/"+ searchOption.path]);
        }
        this.focusOnPlaceInput();
    }

    removeOption(option) {

        let index = this.searchDataService.searchOption.indexOf(option);
        if (index >= 0)
            this.searchDataService.searchOption.splice(index, 1);
        this.focusOnPlaceInput();

        this.onSelectedOption.emit(this.searchDataService.searchOption)
    }

    // focus the input field and remove any unwanted text.
    focusOnPlaceInput() {
        this.autocompleteInput.nativeElement.focus();
        this.autocompleteInput.nativeElement.value = '';
    }

    expandSearch(event){
        if (event==true)
            this.activeClass = "searchbar-expand";
        else this.activeClass = "searchbar";
    }


}
